import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import * as c from "./twoColumn.module.scss";
import classNames from "classnames";
import WistiaVideoPopover from "@components/wistia/wistiaVideoPopover";
import IconPlay from "@components/icons/iconPlay";
import { Text } from "@components/shared/text";

const TwoColumn = ({ className, reverse, children }) => {
  return (
    <section
      data-transition="slide-enter-child"
      className={classNames(className, c.container, { [c.reverse]: reverse })}
    >
      {children}
    </section>
  );
};

TwoColumn.Text = ({ className, children }) => <header className={classNames(className, c.header)}>{children}</header>;
TwoColumn.Text.Eyebrow = ({ className, children }) => (
  <Text variant="eyebrow" as="h1" className={classNames(className, c.eyebrow)}>
    {children}
  </Text>
);
TwoColumn.Text.Headline = ({ className, children }) => (
  <Text variant="h2" className={classNames(className, c.headline)}>
    {children}
  </Text>
);
TwoColumn.Text.Subheading = ({ className, children }) => (
  <Text variant="p2" className={classNames(className, c.subheading)}>
    {children}
  </Text>
);

TwoColumn.Visual = ({ className, children }) => <div className={classNames(className, c.visual)}>{children}</div>;
TwoColumn.Visual.Image = ({ className, image, ...props }) => (
  <GatsbyImage className={className} image={getImage(image)} loading="eager" {...props} />
);
TwoColumn.Visual.WistiaPopover = ({ className, wistiaVideoId, trackedEventName }) => (
  <div className={classNames(className, c.wistiaWrapper)}>
    <WistiaVideoPopover
      className={classNames("scale-enter", c.wistia)}
      wistiaVideoId={wistiaVideoId}
      trackedEventName={trackedEventName}
    >
      <IconPlay className={c.playButton} />
    </WistiaVideoPopover>
  </div>
);

export { TwoColumn };
